import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Skeleton } from '@material-ui/lab';
import List from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/List';
import Step from './Step';


function StepperSkeleton({ classes, expectedSteps }) {
  return (
    <div className={classes.root} test="stepper-skeleton">
      <div className={classes.progressContainer} />
      <div className={classes.stepList}>
        {Array(expectedSteps)
          .fill()
          .map(() => <Skeleton className={classes.skeleton} />)}
      </div>
    </div>
  );
}

StepperSkeleton.propTypes = {
  classes: PropTypes.object.isRequired,
  expectedSteps: PropTypes.number,
};

StepperSkeleton.defaultProps = {
  expectedSteps: 5,
};

function VerticalStepper({
  classes, steps, activeStep, onChange, disabled: disabledProp,
}) {
  if (!steps) {
    return <StepperSkeleton classes={classes} />;
  }
  return (
    <div className={classes.root}>
      <List className={classes.stepList} test="vertical-stepper-step-list">
        {steps.map(({ label, isComplete }, idx) => {
          const disabled = idx !== 0 && !steps[idx - 1].isComplete;
          return (
            <Step
              key={label}
              classes={{ root: classes.step }}
              label={label}
              complete={isComplete}
              active={activeStep === idx}
              disabled={disabled || disabledProp}
              onClick={onChange ? () => onChange(idx) : null}
            />
          );
        })}
      </List>
    </div>
  );
}


VerticalStepper.defaultProps = {
  steps: null,
  onChange: null,
  disabled: false,
};

VerticalStepper.propTypes = {
  classes: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  activeStep: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      isComplete: PropTypes.bool.isRequired,
    }).isRequired,
  ),
};

export default withStyles(theme => ({
  root: {
    display: 'flex',
    height: theme.dimensions.md,
    paddingTop: theme.spacing(4),
  },
  progressContainer: {
    padding: theme.spacing(0.5, 0),
    backgroundColor: theme.palette.facet.backgroundGray,
    borderRadius: theme.radius.xs,
    width: '5px',
  },
  stepList: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    margin: theme.spacing(0, 2),
    gap: '16px',
  },
  step: {
  },
  skeleton: {
    height: 60,
    borderRadius: 10,
  },
}))(VerticalStepper);
